import apiBaseUrl from './api-base';

const getCookie = (name) => {
  if (typeof document === 'undefined') return null;

  const encodedName = `${name}=`;
  const cookies = (document.cookie || '').split(';');

  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(encodedName)) return decodeURIComponent(cookie.slice(encodedName.length));
  }

  return null;
};

const getCredentialsMode = () => (apiBaseUrl.startsWith('/') ? 'same-origin' : 'include');

export const getCsrfToken = () => getCookie('csrf_token');

export const initializeCsrf = async () => {
  if (typeof window === 'undefined') return;

  try {
    await fetch(`${apiBaseUrl}/csrf`, { credentials: getCredentialsMode() });
  } catch (error) {
    // Ignore CSRF bootstrap errors. Mutating requests will surface request failures.
  }
};
